<template>
  <div class="select_dialog_embed">
    <div class="retail_order_embed_msg">
      <div class="select_dialog_embed_box w635">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>
        <!--弹出框信息-->
        <!--导出库存-->
        <div class="select_dialog_embed_box_content export_msg">
          <div><input type="checkbox" id="check_all" v-model="checkAll" @change="allCheck()"><label for="check_all">全选</label></div>
          <ul>
            <li v-for="(item, index) in msg" :key="index">
              <input type="checkbox" title="属性" :id="'msg_' + index" v-model="checkMsg[index]" @change="checkChange()">
              <label :for="'msg_' + index">{{item.name}}</label>
            </li>
          </ul>
         <!-- <ul>
            <li><input type="checkbox" id="basic_msg" v-model="checkMsg.baseMsg" @change="checkBaseMsg()"><label for="basic_msg">基本信息</label></li>
            &lt;!&ndash;<li><input type="checkbox" id="goods_num" v-model="checkMsg.GoodsId" @change="checkChange()"><label for="goods_num">{{msg.GoodsId}}</label></li>&ndash;&gt;
            <li><input type="checkbox" id="goods_name" v-model="checkMsg.GoodsName" @change="checkChange()"><label for="goods_name">{{msg.GoodsName}}</label></li>
            <li><input type="checkbox" id="bar_code" v-model="checkMsg.BarCode" @change="checkChange()"><label for="bar_code">{{msg.BarCode}}</label></li>
            <li><input type="checkbox" id="category" v-model="checkMsg.ClassName" @change="checkChange()"><label for="category">{{msg.ClassName}}</label></li>
            <li><input type="checkbox" id="brands" v-model="checkMsg.BrandName" @change="checkChange()"><label for="brands">{{msg.BrandName}}</label></li>
            <li><input type="checkbox" id="channel_code" v-model="checkMsg.SupplierCode" @change="checkChange()"><label for="channel_code">{{msg.SupplierCode}}</label></li>
            <li><input type="checkbox" id="channel_name" v-model="checkMsg.StoreroomName" @change="checkChange()"><label for="channel_name">{{msg.StoreroomName}}</label></li>
          </ul>
          <ul>
            <li><input type="checkbox" id="relevant_properties" v-model="checkMsg.commodityProperty" @change="checkCommodityProperty()"><label for="relevant_properties">相关属性</label></li>
            <li><input type="checkbox" id="color" v-model="checkMsg.ColorAlias" @change="checkChange()"><label for="color">{{msg.ColorAlias}}</label></li>
            <li><input type="checkbox" id="size" v-model="checkMsg.Size" @change="checkChange()"><label for="size">{{msg.Size}}</label></li>
            <li><input type="checkbox" id="sex" v-model="checkMsg.Gender" @change="checkChange()"><label for="sex">{{msg.Gender}}</label></li>
            <li><input type="checkbox" id="tag_price" v-model="checkMsg.MarketPrice" @change="checkChange()"><label for="tag_price">{{msg.MarketPrice}}</label></li>
            <li><input type="checkbox" id="time_to_market" v-model="checkMsg.MarketSeasoin" @change="checkChange()"><label for="time_to_market">{{msg.MarketSeasoin}}</label></li>
            <li><input type="checkbox" id="discount" v-model="checkMsg.AgentDiscount" @change="checkChange()"><label for="discount">{{msg.AgentDiscount}}</label></li>
            <li><input type="checkbox" id="stock" v-model="checkMsg.Stock" @change="checkChange()"><label for="stock">{{msg.Stock}}</label></li>
          </ul> -->
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_normal" @click="exportGoodsIdStockExcel()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';
    export default {
        name: 'retail-order-embed-msg',
      /**
       *  title：  头部名
       *  showType:
       *  orderMsg: 订单信息
       * */
      props: ['title', 'showType', 'orderMsg'],
      components: {MsgDialog, LoadingDialog},
      watch: {

      },
      data() {
        return {
          msg: [], // 导出库存的选择字段
         /* msg: {
            SupplierCode: '', // 渠道编号
            StoreroomName: '', // 渠道名称
            GoodsId: '', // 货号
            GoodsName: '', // 商品名称
            ColorAlias: '', // 颜色
            Size: '', // 尺码
            BarCode: '', // 条形码
            BrandName: '', // 品牌
            ClassName: '', // 分类
            Gender: '', // 性别
            MarketSeasoin: '', // 上市季节
            MarketPrice: '', // 市场价
            AgentDiscount: '', // 折扣
            Stock: '' // 库存
          }, // 导出库存的选择字段 */
          checkAll: false, // 全选
          checkMsg: [], // 选择的字段id
          isLoading: false, // 是否显示加载框
          loadingType: 'options', // 加载页面类型
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '信息框内容' // 信息框内容
        }
      },
      methods: {
        // 导出库存的导出字段选择
        getStockExportColumn() {
          this.$axios.get(this.Global.getStockExportColumn).then((res) => {
            if (!res.data.errorMsg.length) {
              this.msg = res.data.resData;
              for (let i = 0; i < this.msg.length; i++) {
                this.checkMsg.push(false);
              }
            }
          });
        },

        // 零售下单 导出库存
        exportGoodsIdStockExcel() {
          this.isLoading = true;
          const params = this.orderMsg;
          let arr = [];
          this.$set(params, 'ExportColumn', '');
          for (let i = 0; i < this.checkMsg.length; i++) {
            if (this.checkMsg[i]) {
              arr.push(this.msg[i].id);
            }
          }
          params.ExportColumn = arr.toString();
          this.$axios.post(this.Global.exportGoodsIdStockExcel, params).then((res) => {
            this.isLoading = false;
            if (!res.data.errorMsg.length) {
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 全选改变
        allCheck() {
          if (this.checkAll) {
            for (let i = 0; i < this.checkMsg.length; i++) {
              this.checkMsg[i] = true;
            }
          } else {
            for (let i = 0; i < this.checkMsg.length; i++) {
              this.checkMsg[i] = false;
            }
          }
        },

        // 选择基本属性
        checkChange() {
          let flag = true;
          for (let i = 0; i < this.checkMsg.length; i++) {
            if (!this.checkMsg[i]) {
              flag = false;
            }
          }
          this.checkAll = flag;
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      },
      created() {
        // console.log('参数', this.orderMsg);
        this.getStockExportColumn();
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .retail_order_embed_msg {
    background-color: #fff;
    max-height: 100%;

    .w635 {
      width: 635px;
    }

    .export_msg {
      padding: 15px 15px 0;
      height: 78px;

      ul {
        /*height: 35px;*/
        line-height: 30px;
        margin-left: 40px;
        /*border-bottom: 1px solid #ddd;*/

        li {
          float: left;
          padding-left: 5px;
          padding-right: 5px;

          &:first-child {
            /*padding-left: 0;*/
            /*border-right: 1px dotted #ddd;*/
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/retail-order-embed-msg.vue